import React from 'react';
import Popup from "reactjs-popup";
import Modal from './modal';

class ProductList extends React.Component {

    handleChange = (event) => {
        event.currentTarget.value = parseInt(event.currentTarget.value, 10);
        this.props.updateItemListPrices( event.currentTarget.name, event.currentTarget.value );
    }

    showActionButton(prod, key) {
        const { itemList } = this.props;
        var cart = itemList[key].cart;

        return !cart ? 
            <td className="add-delete"><a onClick={ (event) => this.addToCartAction(prod, key, true, event) } target="_blank">Agregar</a></td>
            :
            <td className="add-delete"><a onClick={ (event) => this.props.deleteFromCart(this.props.category, key) } target="_blank">Quitar</a></td>;
    }

    addToCartAction = (prod, key, cart, event) => {
        const { itemList } = this.props;

        if( itemList[key].value != '' ) {
            event.currentTarget.parentNode.parentNode.classList.toggle('checked');

            //Calculamos la renta
            if( this.props.category == 'renta' ) { prod = this.props.products; }

            this.props.addToCart(prod, key, cart);
        }
    }

    render() {

        const { products, itemList } = this.props;
        var productList = ( products.items && products.items.length > 0 ) ? products.items : ( products.length > 0 ) ? products : [];
        var category = ( products.category !== undefined ) ? products.category : this.props.category;

        return productList.length > 0 ? <div className="slider-products">
                <p>Ingrese un monto en colones y presione agregar</p>

                <div className="container-products">
                    <div style={{overflowX: 'auto'}}>
                        <table>
                            <tbody>
                            { productList.map( (product, idx) => 
                                <tr key={`${category}-item-${idx}`} className={ itemList[`${category}-item-${idx}`].cart ? 'checked' : '' } >
                                    <td className="icon"><object data={products.icon}></object></td>
                                    <td>{product.item}</td>
                                    <td className="information">
                                        { product.info != '' && 
                                            <Popup trigger={ () => <img src="img/help-ico.png" /> } modal closeOnDocumentClick>
                                                {close => (
                                                    <Modal close={close} title="Más detalles" content={product.info} rent={ category == "Renta" } />
                                                )}
                                            </Popup>
                                        }
                                    </td>                                    
                                    <td className="fill"><input type="number" name={`${category}-item-${idx}`} onChange={this.handleChange} value={itemList[`${category}-item-${idx}`].value} placeholder="ej: &cent;1000" /></td>
                                    { this.showActionButton(product, `${category}-item-${idx}`) }
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div> : null;
    }

}

export default ProductList;